import React from "react";
import { ItemType } from "../../models/weeklyTimeline";
import {
  QualityAlertItemComponent,
  DailyNoteItemComponent,
  SupplierNoteItemComponent,
  ProactiveAuditItemComponent,
  AdditionalHoursItemComponent,
  PlantShutdownItemComponent,
  ProductionVolumeItemComponent,
} from "./timeline-items";

interface WeeklyTimelineItemProps {
  item: ItemType;
  isLast: boolean;
  timezone: string;
}

const ITEM_TYPES = {
  QUALITY_ALERT: "Quality Alert",
  NEAR_MISS: "Near Miss",
  DAILY_NOTE: "Daily Note",
  SUPPLIER_NOTE: "Supplier Note",
  PROACTIVE_AUDIT: "Proactive Audit",
  ADDITIONAL_HOURS: "Additional Hours",
  PLANT_SHUTDOWN: "Plant Shutdown",
  CHECK_IN: "Check In",
  PRODUCTION_VOLUME: "Production Volume",
}

const WeeklyTimelineItem: React.FC<WeeklyTimelineItemProps> = ({
  item,
  isLast,
  timezone,
}) => {
  const verticalLineStyle = isLast
    ? ""
    : "border-r-[1px] border-r-gray-500 pb-[2.5rem]";
  const bottomLastMargin = isLast ? "mb-5" : "";

  const timelineItemProps = {
    timezone,
    bottomLastMargin,
    verticalLineStyle,
  };

  switch (item.type) {
    case ITEM_TYPES.QUALITY_ALERT:
      return (
        <QualityAlertItemComponent item={item as any} {...timelineItemProps}/>
      );
    case ITEM_TYPES.DAILY_NOTE:
      return (
        <DailyNoteItemComponent item={item as any} {...timelineItemProps} />
      );
    case ITEM_TYPES.SUPPLIER_NOTE:
      return (
        <SupplierNoteItemComponent item={item as any} {...timelineItemProps} />
      );
    case ITEM_TYPES.PROACTIVE_AUDIT:
      return (
        <ProactiveAuditItemComponent item={item as any} {...timelineItemProps} />
      );
    case ITEM_TYPES.ADDITIONAL_HOURS:
      return (
        <AdditionalHoursItemComponent item={item as any} bottomLastMargin={bottomLastMargin} />
      );
    case ITEM_TYPES.PLANT_SHUTDOWN:
      return (
        <PlantShutdownItemComponent item={item as any} {...timelineItemProps} />
      );
    case ITEM_TYPES.PRODUCTION_VOLUME:
      return (
        <ProductionVolumeItemComponent item={item as any} {...timelineItemProps} />
      );
    default:
      return (
        null
      );
  }
};

export default WeeklyTimelineItem;
